module.exports = __webpack_public_path__ + "assets/text55.png";